(() => {
  const roots = document.querySelectorAll('[data-byp-product]:not([data-byp-bound])');

  const refreshDrawer = async () => {
    const host = document.getElementById('shopify-section-cart-drawer-section');
    if (!host) return false;
    try {
      const response = await fetch('/?sections=cart-drawer-section', { headers: { Accept: 'application/json' } });
      const json = await response.json();
      const html = json['cart-drawer-section'];
      if (!html) return false;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById('shopify-section-cart-drawer-section') || doc.body.firstElementChild;
      if (!fresh) return false;
      host.innerHTML = fresh.innerHTML;
      return true;
    } catch (_) {
      return false;
    }
  };

  const openDrawer = () => {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return false;
    if (typeof drawer.open === 'function') {
      try { drawer.open(); return true; } catch (_) { /* fallback below */ }
    }
    const dialog = drawer.querySelector('dialog');
    if (dialog && typeof dialog.showModal === 'function') {
      try { dialog.showModal(); return true; } catch (_) { /* redirect below */ }
    }
    return false;
  };

  roots.forEach((root) => {
    root.dataset.bypBound = 'true';
    const form = root.querySelector('[data-byp-form]');
    const select = root.querySelector('[data-byp-variant-select]');
    const price = root.querySelector('[data-byp-price]');
    const stickyPrice = root.querySelector('[data-byp-sticky-price]');
    const quantity = root.querySelector('[data-byp-quantity-input]');
    const submit = root.querySelector('[data-byp-submit]');
    const stickySubmit = root.querySelector('[data-byp-sticky-submit]');
    const error = root.querySelector('[data-byp-error]');
    const variantJson = root.querySelector('[data-byp-variants]');
    const optionButtons = [...root.querySelectorAll('[data-byp-option-position]')];
    let variants = [];
    try { variants = JSON.parse(variantJson?.textContent || '[]'); } catch (_) { variants = []; }

    const galleryMain = root.querySelector('.byp-gallery__main');
    const gallerySlides = [...root.querySelectorAll('[data-byp-slide]')];
    const galleryThumbs = [...root.querySelectorAll('[data-byp-thumb]')];
    const isMobileGallery = () => window.matchMedia('(max-width: 959px)').matches;
    const markActiveMedia = (id) => {
      gallerySlides.forEach((slide) => slide.classList.toggle('is-active', slide.dataset.mediaId === id));
      galleryThumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.mediaId === id));
    };
    const showMedia = (mediaId) => {
      if (!mediaId) return;
      const id = String(mediaId);
      const slide = gallerySlides.find((candidate) => candidate.dataset.mediaId === id);
      if (!slide) return;
      markActiveMedia(id);
      if (isMobileGallery() && galleryMain) galleryMain.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    };
    galleryThumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaId)));
    if (galleryMain && gallerySlides.length > 1) {
      let swipeTimer = 0;
      galleryMain.addEventListener('scroll', () => {
        if (!isMobileGallery()) return;
        clearTimeout(swipeTimer);
        swipeTimer = setTimeout(() => {
          const position = galleryMain.scrollLeft;
          const nearest = gallerySlides.reduce((best, slide) => (
            Math.abs(slide.offsetLeft - position) < Math.abs(best.offsetLeft - position) ? slide : best
          ), gallerySlides[0]);
          markActiveMedia(String(nearest.dataset.mediaId));
        }, 90);
      }, { passive: true });
    }

    const setError = (message = '') => {
      if (!error) return;
      error.textContent = message;
      error.classList.toggle('is-visible', Boolean(message));
    };

    const clampQuantity = (next) => {
      if (!quantity) return 1;
      const min = Number(quantity.min || 1);
      const max = quantity.max ? Number(quantity.max) : 99;
      const safe = Math.min(max, Math.max(min, Number(next) || min));
      quantity.value = String(safe);
      return safe;
    };

    root.querySelector('[data-byp-quantity-minus]')?.addEventListener('click', () => clampQuantity(Number(quantity?.value || 1) - 1));
    root.querySelector('[data-byp-quantity-plus]')?.addEventListener('click', () => clampQuantity(Number(quantity?.value || 1) + 1));
    quantity?.addEventListener('change', () => clampQuantity(quantity.value));

    if (select && variants.length && optionButtons.length) {
      const selected = [];
      optionButtons.filter((button) => button.getAttribute('aria-pressed') === 'true').forEach((button) => {
        selected[Number(button.dataset.bypOptionPosition)] = button.dataset.bypOptionValue;
      });

      const syncVariant = () => {
        const match = variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
        if (match) {
          select.value = String(match.id);
          const option = [...select.options].find((item) => item.value === String(match.id));
          if (option?.dataset.price) {
            if (price) price.textContent = option.dataset.price;
            if (stickyPrice) stickyPrice.textContent = option.dataset.price;
          }
          if (submit) submit.disabled = !match.available;
          if (stickySubmit) stickySubmit.disabled = !match.available;
          if (match.featured_media && match.featured_media.id) showMedia(match.featured_media.id);
          try {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', match.id);
            history.replaceState({}, '', url);
          } catch (_) { /* URL state is optional */ }
        }

        optionButtons.forEach((button) => {
          const position = Number(button.dataset.bypOptionPosition);
          const possible = variants.some((variant) => variant.available && variant.options[position] === button.dataset.bypOptionValue && variant.options.every((value, index) => index === position || !selected[index] || value === selected[index]));
          button.disabled = !possible;
        });
      };

      optionButtons.forEach((button) => button.addEventListener('click', () => {
        const position = Number(button.dataset.bypOptionPosition);
        selected[position] = button.dataset.bypOptionValue;
        optionButtons.filter((candidate) => Number(candidate.dataset.bypOptionPosition) === position).forEach((candidate) => candidate.setAttribute('aria-pressed', String(candidate === button)));
        syncVariant();
      }));
      syncVariant();
    }

    const initialOption = select ? [...select.options].find((item) => item.selected) : null;
    if (initialOption) {
      const initialVariant = variants.find((variant) => String(variant.id) === initialOption.value);
      if (initialVariant?.featured_media?.id) showMedia(initialVariant.featured_media.id);
    }

    let busy = false;
    const addToCart = async () => {
      if (busy || !select?.value) return;
      busy = true;
      setError();
      const original = submit?.textContent;
      if (submit) { submit.disabled = true; submit.textContent = submit.dataset.loadingLabel || 'Ajout…'; }
      if (stickySubmit) stickySubmit.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(select.value), quantity: clampQuantity(quantity?.value || 1) }] })
        });
        if (!response.ok) throw new Error('add');
        const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        const cartIcon = document.querySelector('cart-icon');
        if (cartIcon && typeof cartIcon.renderCartBubble === 'function') cartIcon.renderCartBubble(cart.item_count);
        const refreshed = await refreshDrawer();
        if (!refreshed || !openDrawer()) window.location.assign('/cart');
      } catch (_) {
        setError(form?.dataset.errorMessage || 'L’ajout au panier n’a pas abouti. Veuillez réessayer.');
      } finally {
        busy = false;
        if (submit) { submit.disabled = false; submit.textContent = original; }
        if (stickySubmit) stickySubmit.disabled = false;
      }
    };

    form?.addEventListener('submit', (event) => { event.preventDefault(); addToCart(); });
    stickySubmit?.addEventListener('click', addToCart);

    const sticky = root.querySelector('[data-byp-sticky]');
    if (sticky && submit) {
      const scroller = document.querySelector('.page-wrapper') || window;
      const footer = document.querySelector('footer');
      let scheduled = false;
      const updateSticky = () => {
        scheduled = false;
        const buttonPassed = submit.getBoundingClientRect().bottom < 0;
        const footerVisible = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        const visible = buttonPassed && !footerVisible;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', String(!visible));
      };
      const requestUpdate = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(updateSticky);
      };
      [window, document, scroller].forEach((target) => target.addEventListener('scroll', requestUpdate, { passive: true }));
      window.addEventListener('resize', requestUpdate, { passive: true });
      if ('IntersectionObserver' in window) {
        const observerRoot = scroller === window ? null : scroller;
        const observer = new IntersectionObserver(requestUpdate, { root: observerRoot, threshold: [0, 1] });
        observer.observe(submit);
        if (footer) observer.observe(footer);
      }
      updateSticky();
    }
  });
})();
